export const Types = {
    DELETE_TECHNICIAN_FROM_PLANNED: "DELETE_TECHNICIAN_FROM_PLANNED",
    DELETE_TECHNICIAN_FROM_UNPLANNED: "DELETE_TECHNICIAN_FROM_UNPLANNED",

    IS_UPDATED_TASK_CUSTOM_LIST: "IS_UPDATED_TASK_CUSTOM_LIST",
    RESET_IS_UPDATED_TASK_CUSTOM_LIST: "RESET_IS_UPDATED_TASK_CUSTOM_LIST",
};

export const deleteTechnicianFromPlanned = (payload) => ({
    type: Types.DELETE_TECHNICIAN_FROM_PLANNED,
    payload,
});

export const deleteTechnicianFromUnplanned = (payload) => ({
    type: Types.DELETE_TECHNICIAN_FROM_UNPLANNED,
    payload,
});

export const isUpdateTask = () => ({
    type: Types.IS_UPDATED_TASK_CUSTOM_LIST,
});

export const resetIsUpdateTask = () => ({
    type: Types.RESET_IS_UPDATED_TASK_CUSTOM_LIST,
});

